<template>
  <v-row>
    <v-col cols="12" :md="show_second_list ? '6' : '12'">
      <v-autocomplete
        v-model="start_range"
        :items="calendar"
        label="Fecha efectiva (Semana a aplicar)"
        color="cyanText"
        prepend-inner-icon="today"
        required
        return-object
        dense
        item-value="date_begin"
        item-text="text"
        hide-details
        outlined :disabled="disabled"
        @change="update_range('one')"
      >
        <template v-slot:append-outer>
          <v-menu v-model="menuOpen" :close-on-content-click="false" :key="menu_key">
            <template v-slot:activator="{ attrs, on }">
              <v-icon v-bind="attrs" v-on="on" v-if="show_settings">settings</v-icon>
            </template>
            <v-list>
              <!-- <v-list-item>
                <v-list-item-title>
                  <v-btn text @click="select_frequency(1)">
                    Calendario semanal
                  </v-btn>
                </v-list-item-title>
              </v-list-item>
              <v-list-item>
                <v-list-item-title>
                  <v-btn text @click="select_frequency(3)">
                    Calendario quincenal
                  </v-btn>
                </v-list-item-title>
              </v-list-item> -->
              <v-list-item>
                <v-list-item-title>
                  <v-text-field
                    dense v-model="year"
                    hide-details @change="update_year()"
                    label="Año" :min="2000" :max="2050"
                    outlined type="number"
                    @mousedown.stop
                  ></v-text-field>
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
      </v-autocomplete>
    </v-col>
    <v-col cols="12" md="6" v-if="show_second_list">
      <v-autocomplete
        v-model="end_range"
        :items="end_calendar"
        label="Fecha final (Ultima semana)"
        color="cyanText"
        prepend-inner-icon="event"
        required
        dense no-data-text="Escoja el rango inicial"
        item-value="date_begin"
        item-text="text"
        hide-details
        outlined :disabled="disabled"
        return-object
        @change="update_range('two')"
      ></v-autocomplete>
    </v-col>
  </v-row>
</template>
<script>
import moment from "moment";
export default {
  name: "GeneralGhCalendar",
  data: () => ({
    calendar: [],
    frequencies:[{id:1,text:"Semana",max_period:52},{id:3,text:"Quincena",max_period:24}],
    start_range: null,
    end_range: null,
    menuOpen: false,
    year: moment().format("YYYY"),
    frequency_selected:1
  }),
  props: {
    show_second_list: {
      type: Boolean,
      default: false,
    },
    update_second_with_one: {
      type: Boolean,
      default: false,
    },
    automatic_selection: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    show_settings: {
      type: Boolean,
      default: false,
    },
    range_pre_selected:{
      type: Object,
      default() {
        return {
          start: null,
          end: null,
        };
      },
    },
    sort: {
      type: String,
      default: "desc",
    },
  },
  computed: {
    end_calendar() {
      if(this.start_range==null){
        return []
      }
      return this.calendar.filter((element) =>parseInt(element.period_number) >=parseInt(this.start_range.period_number));
    },
    menu_key(){
      if(this.start_range==null){
        return '0';
      }
      return this.start_range.date_begin;
    }
  },
  mounted() {
    this.select_frequency(1);
  },
  methods: {
    async get_calendar() {
        this.calendar=[];
        const calendar_result = await this.api_Get(`income/general_calendar/${this.year}/${this.frequency_selected}`);
        const data_calendar = await calendar_result.json();
        if(data_calendar.length==0){
            this.infoNotification('Calendario no encontrado!');
            return
        }
        let last_week = null;
        const frequency =this.frequencies.find((element)=>element.id==this.frequency_selected);
        for (let item of data_calendar) {
            item.text = `${frequency.text} (${this.filLeft(item.period_number.toString(),2,'0')}) desde ${moment(item.date_begin).format("DD/MM/YYYY")} hasta ${moment(item.date_end).format("DD/MM/YYYY")}`;
            if(last_week==null && item.is_current){
                last_week=item;
            }
            item.is_current = false;
            this.calendar.unshift(item);
        }
        if (this.automatic_selection && last_week!=null) {
            const index = this.calendar.findIndex((element) => element.period_number === last_week.period_number);
            if (index !== -1) {
                this.start_range = this.calendar[index];
                this.end_range = this.calendar[index];
                this.calendar[index].is_current = true;
            }
        }
        //SI REVIBE UN RAGO ESTABLECIDO (PARA ACTUALIZAR) 
        function set_preselected_range(validate,calendar){
          if(validate==null){
            return null;
          }            
            const find_range=calendar.find((element)=>element.period_number==validate); 
            if(find_range==undefined){
              return null
            }
           return find_range;
        }
        const set_start = set_preselected_range(this.range_pre_selected?.start,this.calendar);
        if(set_start!=null){
          this.start_range=set_start;
        }
        const set_end = set_preselected_range(this.range_pre_selected?.end,this.calendar);
        if(set_end!=null){
          this.end_range=set_end;
        }
        if(this.start_range!=null){
          this.$emit("set_range", {start:this.start_range,end:this.end_range,is_init:true});
        }
    },
    select_frequency(frequency) {
      this.menuOpen = false;
      this.frequency_selected=frequency;
      this.get_calendar();
    },
    update_range(origin) {
      if(origin=='one' && this.update_second_with_one && this.end_range==null){
        this.end_range=this.start_range;
      }
      if (this.end_range != null && parseInt(this.start_range.period_number) > parseInt(this.end_range.period_number)) {
        this.end_range = this.start_range;
      }
      this.$emit("set_range", {start:this.start_range,end:this.end_range,is_init:false});
    },
    update_year(){
        if(this.year<2000 || this.year>2025){
            this.errorNotification("Año no valido!");
            return
        }
        this.get_calendar();
    }
  },
};
</script>
